import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import cookies from 'js-cookie';
import classNames from 'classnames';
import swal from 'sweetalert';
import { BsTwitterX } from 'react-icons/bs';

// Components & Services
import Search from './common/Search';
import Sidebar from './common/Sidebar';
import StickyMenu from './common/StickyMenu';
import MobileMenu from './common/MobileMenu';
import { Styles } from "./styles/headerTwo.js";
import RenderOnAnonymous from '../pages/account/RenderOnAnonymous';
import RenderOnAuthenticated from '../pages/account/RenderOnAuthenticated';
import RenderOnRole from '../pages/account/RenderOnRole';
import UserService from '../services/UserService';
import service from '../services/service';

// Assets
import logo from '../assets/images/tnpa-Footer-logo.png';

const languages = [
    { code: 'en', name: 'English', country_code: 'gb' },
    // { code: 'hi', name: 'Hindi', country_code: 'in' },
    { code: 'ta', name: 'Tamil', country_code: 'in' },
    // { code: 'te', name: 'Telugu', country_code: 'in' },
];

function HeaderTwo() {
    const history = useHistory();
    const { t } = useTranslation();
    const currentLanguageCode = cookies.get('i18next') || 'en';
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

    useEffect(() => {
        UserService.generateToken();
        document.body.dir = currentLanguage?.dir ?? "ltr";
        document.title = t('app_title');

        let browser = UserService.FireFoxModal();
        // if (browser === "Firefox") testSwal();
    }, [currentLanguage, t]);

    const afterLogout = () => {
        let userId = UserService.getUserid();
        let sessionId = UserService.getSessionId();
        service.updateUserActionDetails(userId, sessionId);
        history.push("/");
    };

    const testSwal = () => {
        swal({
            title: 'Browser Information',
            text: 'Recommended to use Google Chrome, Brave, or Microsoft Edge!',
            icon: 'warning',
            buttons: false,
            timer: 5000,
        });
    };

    return (
        <Styles>
            {/* --- DESKTOP TOP BAR (Hidden on Mobile) --- */}
            <div className="top-bar-modern desktop-only">
                <Container className="d-flex justify-content-between align-items-center">
                    <div className="contact-info">
                        <a href="tel:+9109498180955"><i className="las la-phone"></i> {t("call_us_phone")}</a>
                        <a href="mailto:info.tnpa@gmail.com"><i className="las la-envelope"></i> {t("enquiry_us_id")}</a>
                    </div>
                    <div className="top-right-actions d-flex align-items-center">
                        <div className="social-links">
                            <a href="https://facebook.com" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://x.com" target="_blank" rel="noreferrer"><BsTwitterX /></a>
                            <a href="https://youtube.com" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
                        </div>

                        <Dropdown className="lang-dropdown">
                            <Dropdown.Toggle><i className="las la-language"></i> {currentLanguage?.name}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {languages.map(({ code, name }) => (
                                    <Dropdown.Item
                                        key={code}
                                        className={classNames({ active: currentLanguageCode === code })}
                                        onClick={() => i18next.changeLanguage(code)}
                                    >
                                        {name}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>

                        <RenderOnAuthenticated>
                            <button className="auth-btn logout" onClick={() => [afterLogout(), UserService.doLogout()]}>
                                <i className="las la-sign-out-alt"></i> <span>{t('log_out')}</span>
                            </button>
                        </RenderOnAuthenticated>
                        <RenderOnAnonymous>
                            <button className="auth-btn login" onClick={UserService.doLogin}>
                                <i className="las la-user"></i> <span>{t('log_in')}</span>
                            </button>
                        </RenderOnAnonymous>
                    </div>
                </Container>
            </div>

            {/* --- DESKTOP MAIN HEADER (Hidden on Mobile) --- */}
            <header className="main-header-area desktop-only">
                <Container>
                    <div className="header-inner-box">
                        <div className="logo-brand">
                            <Link to="/">
                                <img src={logo} alt="Logo" />
                                <div className="brand-text">
                                    <h3 className="gradient-text">TNP-eKalvi</h3>
                                    <p>TAMIL NADU POLICE ACADEMY</p>
                                </div>
                            </Link>
                        </div>

                        <nav className="main-menu-nav">
                            <ul className="nav-list">
                                <li className="nav-item"><Link to="/">{t('home')}</Link></li>
                                <li className="nav-item"><Link to="/about">{t('about_us')}</Link></li>

                                <li className="nav-item has-dropdown">
                                    <Link to="#">{t('courses')} <i className="las la-angle-down"></i></Link>
                                    <ul className="dropdown-list">
                                        <RenderOnAuthenticated>
                                            <RenderOnRole roles={['instructor']}>

                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/CourseStructureDrive"}>{t('course_Content_Drive')}</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/add-course-category"}>{t('course_Category')}</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/CreateCourse"}>{t('create_course')}</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/ViewCourses"}>{t('authored_Courses')}</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/clone-course"}>{t('clone_course')}</Link></li>
                                            </RenderOnRole>
                                            <RenderOnRole roles={['learner']}>
                                                {/* <li className="nav-item"><Link className="nav-link" to="/user-grid">{t('my_courses')}</Link></li> */}
                                            </RenderOnRole>
                                        </RenderOnAuthenticated>
                                        <li className="nav-item"><Link className="nav-link" to="/course-grid">{t('all_courses')}</Link></li>
                                    </ul>
                                </li>

                                <li className="nav-item has-dropdown">
                                    <Link to="#">{t('e-library')} <i className="las la-angle-down"></i></Link>
                                    <ul className="dropdown-list">
                                        <li><Link to="/library-content">{t('all_book')}</Link></li>
                                        <RenderOnAuthenticated>
                                            <RenderOnRole roles={['instructor']}>
                                                <li><Link to="/create-library">{t('create_library')}</Link></li>
                                            </RenderOnRole>
                                        </RenderOnAuthenticated>
                                    </ul>
                                </li>

                                <RenderOnAuthenticated>
                                    <li className="nav-item has-dropdown">
                                        <Link to="#">{t('dashboard')} <i className="las la-angle-down"></i></Link>
                                        <ul className="dropdown-list">
                                            {UserService.hasRole(['instructor']) ? (
                                                <li><Link to="/instructor-dashboard">{t('instructor_Dashborad')}</Link></li>
                                            ) : UserService.hasRole(['admin']) ? (
                                                <li><Link to="/AdminDashBoard">{t('admin_Dashborad')}</Link></li>
                                            ) : (
                                                <>
                                                    {/* <li className="nav-item"><Link className="nav-link" to="/extensions/calendar">{t('learner_Dashboard')}</Link></li> */}
                                                    <li className="nav-item">
                                                        <Link className="nav-link" to={`${process.env.PUBLIC_URL}/dashboard`}>{t('learner_Dashboard')}</Link>
                                                    </li>
                                                </>
                                            )}
                                        </ul>
                                    </li>
                                </RenderOnAuthenticated>

                                <li className="nav-item"><Link to="/contact">{t('contact')}</Link></li>
                            </ul>
                        </nav>

                        <div className="header-right-meta">
                            <div className="search-trigger">
                                <Search />
                            </div>
                            <RenderOnAnonymous>
                                <Link to="/registration" className="register-pill">
                                    {t('register')}
                                </Link>
                            </RenderOnAnonymous>
                            <div className="sidebar-trigger">
                                <Sidebar />
                            </div>
                        </div>
                    </div>
                </Container>
            </header>

            {/* Mobile-only components (Controlled by their own internal media queries) */}
            <StickyMenu />
            <MobileMenu />
        </Styles>
    )
}

export default HeaderTwo;